export default __webpack_public_path__ + "static/media/luggage-storage.inline.d76171cb.svg";